import { render, staticRenderFns } from "./ChbEditPageHeader.vue?vue&type=template&id=07005935&scoped=true"
import script from "./ChbEditPageHeader.vue?vue&type=script&lang=js"
export * from "./ChbEditPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ChbEditPageHeader.vue?vue&type=style&index=0&id=07005935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07005935",
  null
  
)

export default component.exports